import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BrandIcon from './BrandIcon';

const NAV_ITEMS = [
  { to: '/document-analysis', label: '문서분석', icon: 'document' },
  { to: '/prediction', label: '결과예측', icon: 'prediction' },
  { to: '/draft', label: '서류작성', icon: 'draft' },
  { to: '/ai-tools', label: 'AI 도구', icon: 'tools' },
  { to: '/digital-twin', label: '디지털 트윈', icon: 'map' },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <nav className="app-navbar relative z-50 shrink-0" aria-label="상단 메뉴">
      <div className="px-4 py-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 min-h-11 shrink-0" aria-label="마이로잇 홈">
            <span className="h-9 w-9 rounded-2xl bg-[#1f2933] text-[#f6f1e8] flex items-center justify-center shadow-sm">
              <BrandIcon name="logo" size={20} title="마이로잇" />
            </span>
            <span className="text-base sm:text-lg font-bold text-[#1f2933] whitespace-nowrap">마이로잇</span>
          </Link>
          {/* 신기능 네비게이션 */}
          <div className="hidden lg:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <Link key={item.to} to={item.to}
                className="px-3 py-1.5 text-xs font-medium text-[#5f554b] hover:text-[#1f2933] hover:bg-white/55 rounded-lg transition-colors inline-flex items-center gap-1.5">
                <BrandIcon name={item.icon} size={15} />
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {user ? (
          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="계정 메뉴"
              aria-expanded={menuOpen}
              aria-controls="account-menu"
              className="flex items-center gap-2 min-h-11 px-3 py-2 rounded-xl hover:bg-white/55 transition-colors"
            >
              <span className="h-7 w-7 rounded-full bg-white/70 text-[#5f554b] flex items-center justify-center border border-[#e2d6c8]">
                <BrandIcon name="user" size={16} />
              </span>
              <span className="text-sm font-medium text-gray-700 hidden sm:inline">
                {user.nickname || user.name}
              </span>
              <svg className={`w-4 h-4 text-gray-400 transition-transform ${menuOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {menuOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />
                <div id="account-menu" className="account-menu absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-[#e2d6c8] py-2 z-50">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-800">{user.nickname || user.name}</p>
                    <p className="text-xs text-gray-400 truncate">{user.email}</p>
                  </div>
                  <Link to="/mypage" onClick={() => setMenuOpen(false)}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                    마이페이지
                  </Link>
                  <Link to="/history" onClick={() => setMenuOpen(false)}
                    className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-white/55 transition-colors">
                    <BrandIcon name="history" size={16} /> 검색 이력
                  </Link>
                  {/* 모바일에서 신기능 링크 */}
                  <div className="lg:hidden border-t border-gray-100 mt-1 pt-1">
                    {NAV_ITEMS.map((item) => (
                      <Link key={item.to} to={item.to} onClick={() => setMenuOpen(false)}
                        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-white/55">
                        <BrandIcon name={item.icon} size={16} /> {item.label}
                      </Link>
                    ))}
                  </div>
                  {user.isAdmin && (
                    <Link to="/admin" onClick={() => setMenuOpen(false)}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-[#7a4b20] hover:bg-white/55 transition-colors border-t border-gray-100 mt-1 pt-2">
                      <BrandIcon name="admin" size={16} /> 관리자 ERP
                    </Link>
                  )}
                  <button onClick={() => { logout(); setMenuOpen(false); }}
                    className="block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-red-50 transition-colors">
                    로그아웃
                  </button>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-1 shrink-0">
            <Link to="/login"
              className="inline-flex items-center min-h-11 px-2 sm:px-3 text-sm font-medium text-[#5f554b] hover:text-[#1f2933] transition-colors">
              로그인
            </Link>
            <Link to="/register"
              className="inline-flex items-center min-h-11 px-3 text-sm font-semibold text-[#f6f1e8] bg-[#1f2933] rounded-xl hover:bg-[#34414d] transition-colors">
              회원가입
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
